import { Injectable } from '@angular/core';
import { Route, Router, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthServicesService } from '../auth/services/auth-services.service';
import { Store } from '@ngrx/store';
import { clearReducer } from '../auth/state/auth.actions';
import { NpsSurveyService } from '../click-it/nps-survey/nps-survey.service';

@Injectable({
  providedIn: 'root',
})
export class DashboardModuleGuard  {
  OtpData: any;
  constructor(
    private readonly authService: AuthServicesService,
    private readonly router: Router,
    private readonly store: Store<any>,
    private readonly npsService: NpsSurveyService
  ) {
    this.store
      .select((state) => state)
      .subscribe((data) => {
        this.OtpData = data?.authReducer?.otpVerifiedDetails;
      });
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (this.authService.isLoggedIn()) {
      return true;
    } else {
      if (!this.OtpData?.tnc_accepted) {
        this.npsService.stopHeartbeat();
        this.authService.logout().subscribe({
          next: (res) => {
            if (res.msg === 'Logout successfully!') {
              console.log(localStorage.getItem('languageDirection'));
              this.store?.dispatch(clearReducer());
              this.router.navigate(['login']);
            }
          },
          error: (err) => {},
        });
      }
      this.router.navigate(['login']);
      return false;
    }
  }
}
